import { IRule } from './rule';
import { AppInjector } from 'projects/dop-core/src/public-api';
import { Recipient } from '../../models/recipient.model';
import { ContactType } from '../../enums/contact-type.enum';
import { OrderCommandService } from '../../data-service/order-command.service';
import { CurrentOrder } from '../../models/current-order.model';
import { OrderState } from '../../enums/order-state.enum';
import { OrderValidationResult } from '../models/order-validation-result.model';
import { DocumentType } from '../../enums/document-type.enum';

export class OrderRecipientsRule implements IRule {

    nimsRecipients: Recipient[];
    orderCommandService: OrderCommandService;
    currentOrder: CurrentOrder;

    constructor(currentOrder: CurrentOrder, recipients: Recipient[]) {
        const injector = AppInjector.getInjector();
        this.nimsRecipients = recipients;
        this.currentOrder = currentOrder;
        this.currentOrder.recipients.map(t => {
            t.analyticalReport = t.informationToSend.some(c => c.documentType === DocumentType.AnalyticalReport);
            t.analyticalReportCopy = t.informationToSend.some(c => c.documentType === DocumentType.AnalyticalReportCopy);
            t.invoice = t.informationToSend.some(c => c.documentType === DocumentType.InvoiceDocument);
        });
        this.orderCommandService = injector.get(OrderCommandService);
    }

    async validate(): Promise<OrderValidationResult> {
        let deletedRecipients: Recipient[];
        let newlyAddedRecipients: Recipient[];
        if (this.currentOrder.recipients && this.currentOrder.recipients.length > 0
            && this.nimsRecipients) {
            deletedRecipients = this.currentOrder.recipients
                .filter(r => r.contactType === ContactType.Configured &&
                    !(this.nimsRecipients.map(rr => rr.email).indexOf(r.email) !== -1));
        }
        if (this.nimsRecipients && this.nimsRecipients.length > 0) {
            newlyAddedRecipients = this.nimsRecipients
                .filter(r => this.currentOrder.recipients ?
                    !(this.currentOrder.recipients.map(a => a.email).indexOf(r.email) !== -1) : true);
        }
        const invalidRecipients = deletedRecipients ? deletedRecipients.map(c => c.id) : [];
        if (this.currentOrder.orderState === OrderState.Pending ||
            this.currentOrder.orderState === OrderState.EditFavoriteOrder) {
            if (invalidRecipients && invalidRecipients.length > 0) {
                invalidRecipients.forEach(r => {
                    this.currentOrder.recipients = this.currentOrder.recipients
                        .filter(c => c.id !== r);
                    this.orderCommandService.deleteRecipient(this.currentOrder.OrderCode, r)
                        .toPromise().then(_ => { });
                });
            }
        }
        if (this.currentOrder.orderState === OrderState.Submitted || this.currentOrder.orderState === OrderState.FavoriteOrder) {
            this.currentOrder.recipients = this.currentOrder.recipients.filter(re => !(invalidRecipients.indexOf(re.id) !== -1));
        }
        if (newlyAddedRecipients && newlyAddedRecipients.length > 0) {
            this.currentOrder.recipients.forEach(x => x.id = undefined);
            const res = await this.orderCommandService.addUpdateRecipient(this.currentOrder.OrderCode, this.currentOrder.recipients.concat(newlyAddedRecipients)).toPromise();
            this.currentOrder.recipients = [];
            this.currentOrder.recipients = this.currentOrder.recipients.concat(res);
        }
        const result = new OrderValidationResult();
        result.isValid = true;
        result.newRecipients = newlyAddedRecipients;
        return result;
    }
}
